import React, { useEffect, useState } from 'react';
import { Message } from 'rsuite';
import { Button, Modal, useLastPresent } from '@nsi-advisory-services/components';
import PermissionPicker from './PermissionPicker';
import { ADMIN_PERMISSION, toGrantedPermissionList, toPermissionGrantsObject } from '../../config/permissions';
import { useUpdateEmployee } from '../../hooks/useQueries';

/** Edits one employee's direct permission grants. Open while `employee` is set. */
export default function PermissionGrantsModal({ employee, onClose }) {
  const updateEmployee = useUpdateEmployee();
  const [granted, setGranted] = useState([]);
  const employeeShown = useLastPresent(employee); // keeps the dialog steady while it fades out

  useEffect(() => {
    if (employee) setGranted(toGrantedPermissionList(employee.permission_grants));
  }, [employee]);

  const save = async () => {
    try {
      await updateEmployee.mutateAsync({ id: employee.id, permission_grants: toPermissionGrantsObject(granted) });
      onClose();
    } catch {
      // Shown in the dialog.
    }
  };

  return (
    <Modal open={Boolean(employee)} onClose={onClose} onExited={() => updateEmployee.reset()} size="sm">
      <Modal.Header>
        <Modal.Title>Permissions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          <strong>{employeeShown?.first_name} {employeeShown?.last_name}</strong>
          <div className="text-muted" style={{ fontSize: 13 }}>{employeeShown?.email || ''}</div>
        </div>
        <PermissionPicker value={granted} onChange={setGranted} />
        {granted.includes(ADMIN_PERMISSION) ? (
          <div className="text-muted mt-2" style={{ fontSize: 13 }}>
            Administrator covers every permission, including any added later.
          </div>
        ) : null}
        {updateEmployee.error ? (
          <Message type="error" showIcon className="mt-3">
            {String(updateEmployee.error?.message || updateEmployee.error)}
          </Message>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} disabled={updateEmployee.isPending}>Cancel</Button>
        <Button variant="primary" onClick={save} loading={updateEmployee.isPending}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
